import {
  DateRangePicker as DateRangePickerBase,
  type DateRangePickerProps,
} from "$components/inputs";
import React from "react";
import { useIntl } from "react-intl";

export const DateRangePicker: React.FunctionComponent<
  Omit<DateRangePickerProps, "labelFrom" | "labelTo">
> = (props) => {
  const { formatMessage } = useIntl();

  return (
    <DateRangePickerBase
      {...props}
      labelFrom={formatMessage({
        id: "dateRangePicker.from",
        defaultMessage: "From",
      })}
      labelTo={formatMessage({
        id: "dateRangePicker.to",
        defaultMessage: "To",
      })}
    />
  );
};
